import type { IAddress } from '@/interfaces/IAddress'
import type { IUserForm } from '@/interfaces/users/IUserForm'
import type { IUserNextOfKinDetail } from '@/interfaces/users/IUserNextOfKinDetail'
import Address from '../Address'
import NextOfKinDetail from '../NextOfKinDetail'
import Base from '../Base'

class UserForm extends Base implements IUserForm {
  name: string

  email: string

  role: string

  designation?: string

  teamTitle?: string

  employeeCode?: string

  phoneNumber?: string

  alternatePhoneNumber?: string

  dateOfBirth?: string

  nextOfKinDetail: IUserNextOfKinDetail

  address: IAddress

  constructor(user?: any) {
    super(user)
    this.name = user?.name
    this.email = user?.email ?? null
    this.role = user?.roles ? user?.roles[0] : null
    this.designation = user?.designation ?? null
    this.teamTitle = user?.teamTitle ?? null
    this.employeeCode = user?.employeeCode ?? null
    this.phoneNumber = user?.phoneNumber ?? null
    this.alternatePhoneNumber = user?.alternatePhoneNumber ?? null
    this.dateOfBirth = user?.dateOfBirth ?? null
    this.nextOfKinDetail = new NextOfKinDetail(user?.nextOfKinDetail)
    this.address = new Address(user?.address)
  }
}

export default UserForm
